import { PLANT_API_BASE_URL } from 'shared/constants/constants';

export const PlantDesignConstants = {
  licenceType: 'PDRA',
  licenceTypeDescription: 'Plant Design Registration - New',
  applicantType: 'individual',
  duration: 'perpetual',
  transactionType: 'New',
  itemCount: 1,
  designerAndVerifierStatementUrl:
    'https://www.safework.nsw.gov.au/__data/assets/pdf_file/0007/1107079/plant-design-designer-and-design-verifier-statement.pdf',
};

export const PLANT_DESIGN_API_BASE_URL = `${PLANT_API_BASE_URL}/design`;
